module.exports = __webpack_public_path__ + "img/ngo_facebook_contact.213fdcfa.png";